<template>
    <div>
        <ExpireHeader header="สินค้าคืนไม่ได้รอย้ายเข้าคลังทิ้ง" :img_header="header_image" link_back="stock/storage/expirestorage"/>
        <Drop_product/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/trash-bin_1.png'
    import ExpireHeader from "@/components/admin/stock/storage_expire/header_expire/ExpireHeader.vue";
    import Drop_product from "@/components/admin/stock/storage_expire/Drop_product.vue";
    export default {
        name: "DropRefun",
        components: {
            Drop_product,
            ExpireHeader
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
